module.exports = __webpack_public_path__ + "img/stock2.28e76082.png";